import { Component } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { ICustomerTeltonikaService, IHIPTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'huge-monorepo-teltonika-update-device-by-version',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './teltonika-update-device-by-version.component.html',
  styleUrl: './teltonika-update-device-by-version.component.scss',
})
export class TeltonikaUpdateDeviceByVersionComponent {
  versionControl = new FormControl<number | null>(null, [Validators.min(1), Validators.required]);
  teltonikaService = this.teltonikaSingleton.getService();

  constructor(private teltonikaSingleton: SharedTeltonikaSingletonService<IHIPTeltonikaService | ICustomerTeltonikaService>, private toastr: ToastrService, private location: Location) { }

  close() {
    this.location.back();
  }

  updateTeltonikaDevicesByVersion(): void {
    if (this.versionControl.invalid) {
      this.versionControl.markAsTouched();
      return;
    }

    this.teltonikaService.updateDeviceByVersion(this.versionControl.value).subscribe({
      next: (resp) => {
        if (!resp) {
          this.toastr.error('Error Updating Devices');
        } else {
          this.toastr.success('Updated Devices');
          this.close();
        }
      },
      error: (err) => {
        this.toastr.error('Error Updating Devices');
      }
    });
  }
}
